import React, { useEffect, useState } from 'react'
import { Search, XCircleFill } from 'react-bootstrap-icons'
import Select, { SingleValue } from 'react-select'

import useDebounce from '../../../hooks/useDebounce'
import { useDispatch } from '../../../modules/store/customDispatch'
import { useSelector } from '../../../modules/store/customSelector'
import { useGetPartsSelectSearchWarehousePlaceMutation } from '../../../modules/store/datahubApi/datahubApi'
import { storeDispatchTypes } from '../../../modules/store/storeDispatchTypes'
import { IOption, SortFieldParts, SortIconType, SortOrder } from '../../../types/common/commonTypes'
import ColumnSort from '../ColumnSort/ColumnSort'

import styles from './styles.module.scss'

const TableHeadWarehousePlaceSearchParts = () => {
    const dispatch = useDispatch()
    const warehousePlaceFilter = useSelector(state => state.partList.filters.warehousePlace)

    const [isEditing, setIsEditing] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [options, setOptions] = useState<IOption[]>([])
    const [isSortActive, setIsSortActive] = useState(false)

    const debouncedValue = useDebounce(inputValue, 300)

    const [fetchOptions, { isLoading, data }] = useGetPartsSelectSearchWarehousePlaceMutation()

    const sortOrderCurrent = useSelector(state =>
        state.partList.sortOrder.find(item => item[0] === SortFieldParts.WAREHOUSE_PLACE),
    )

    const handleChange = (option: SingleValue<IOption>) => {
        setIsEditing(false)

        dispatch({
            type: storeDispatchTypes.setAnyTextFilterParts,
            value: {
                key: 'warehousePlace',
                value: option?.value || null,
            },
        })
    }

    const handleReset = (e?: React.MouseEvent) => {
        e?.stopPropagation()

        dispatch({
            type: storeDispatchTypes.setAnyTextFilterParts,
            value: {
                key: 'warehousePlace',
                value: '',
            },
        })
        dispatch({
            type: storeDispatchTypes.setPartListSort,
            value: {
                sortField: SortFieldParts.WAREHOUSE_PLACE,
                sortOrder: SortOrder.NONE,
            },
        })
    }

    useEffect(() => {
        if (debouncedValue.trim()) {
            fetchOptions({ search: debouncedValue })
        }
    }, [debouncedValue, fetchOptions])

    useEffect(() => {
        const warehousePlaces = data?.warehousePlaces

        if (warehousePlaces?.length) {
            const mapped = warehousePlaces.map(item => ({
                value: item,
                label: item,
            }))
            setOptions(mapped)
        }
    }, [data])

    useEffect(() => {
        if (isEditing) {
            fetchOptions({ search: '' })
        }
    }, [fetchOptions, isEditing])

    useEffect(() => {
        setIsSortActive(!!sortOrderCurrent)
    }, [sortOrderCurrent])

    return (
        <div className={styles.headWrap}>
            <div className={styles.headContent}>
                <div onClick={() => setIsEditing(true)}>
                    <span>{'Место'}</span>
                    {!warehousePlaceFilter && <Search className={'ms-2'} color="#C4C4C4" size={14} />}
                </div>

                <ColumnSort
                    iconType={SortIconType.NUMERIC}
                    sortField={SortFieldParts.WAREHOUSE_PLACE}
                    slice={'partList'}
                    reverseSort={false}
                    isResetButton={false}
                    handleSortChange={setIsSortActive}
                />
                {(isSortActive || warehousePlaceFilter) && (
                    <span className={styles.clearIcon} onClick={handleReset}>
                        <XCircleFill color="grey" size={14} />
                    </span>
                )}
            </div>

            {isEditing && (
                <div className={styles.selectWrapper}>
                    <Select
                        autoFocus
                        menuIsOpen
                        placeholder="Выберите место"
                        isClearable
                        value={options.find(o => o.value === warehousePlaceFilter) || null}
                        options={options}
                        isLoading={isLoading}
                        onChange={handleChange}
                        onInputChange={setInputValue}
                        onBlur={() => setIsEditing(false)}
                        noOptionsMessage={() => 'Ничего не найдено'}
                        loadingMessage={() => 'Загрузка...'}
                        styles={{
                            control: provided => ({
                                ...provided,
                                borderColor: 'transparent',
                                boxShadow: 'none',
                                '&:hover': {
                                    borderColor: 'transparent',
                                },
                            }),
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default TableHeadWarehousePlaceSearchParts
